// extracted by mini-css-extract-plugin
module.exports = {"appBar__wrapper":"admin-portal__AppBar__appBar__wrapper","appBar__logo":"admin-portal__AppBar__appBar__logo"};